import $ from 'jquery';
import { getState } from '~src/state';

export function textFontSize() {
  const text = getState('activeObject');

  if (!text) {
    return;
  }

  window.canvas.on('object:scaling', (event) => {
    const activeObject = getState('activeObject');

    if (!activeObject || activeObject.type !== 'textbox') {
      return;
    }

    const transform = event['transform'];
    const target = transform['target'];
    if (target) {
      const fontSize = (target.fontSize * target.scaleX) / 10;
      $('#editor-font-size-input').val(fontSize.toFixed(0));
    }

    // var selected = e.target;
    // selected.set({
    //   height: selected.height * selected.scaleY,
    //   width: selected.width * selected.scaleX,
    //   scaleX: 1,
    //   scaleY: 1
    // });
  });

  text.on('modified', function () {
    // const activeObject = getState('activeObject');
    // if (!activeObject || activeObject.type !== 'textbox') {
    //   return;
    // }
    // const target = event['target'];
    // if (Math.abs(target.scaleX) > Math.abs(target.oldScale)) {
    //   return true; //scaling up!
    // } else {
    //   return false; //scaling down!
    // }
    // console.log("textFontSize -> target", target)
    // if (target) {
    //   const fontSize = target.fontSize * target.scaleX;
    //   text.set('fontSize', parseInt(fontSize, 10));
    //   // event.target.fontSize *= event.target.scaleX;
    //   let targetScaleX = 1;
    //   if (target.scaleX > 1.5) {
    //     targetScaleX = 1.5;
    //   } else {
    //     targetScaleX = target.scaleX;
    //   }
    //   const width = target.width * targetScaleX;
    //   text.set('width', width);
    //   text.set('scaleY', 1);
    //   text.set('scaleX', 1);
    //   text._clearCache();
    // }
  });
}
